import { render } from "./changesignature.vue?vue&type=template&id=9e15953e&scoped=true"
import script from "./changesignature.vue?vue&type=script&lang=js"
export * from "./changesignature.vue?vue&type=script&lang=js"

import "./changesignature.vue?vue&type=style&index=0&id=9e15953e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e15953e"]])

export default __exports__